import React, { useEffect, useState } from 'react'
import util from 'meinian-package/src/utils/util'
import Panel from '../panel'
import MouseIcon from '../component/mouseIcon'
import Nav from '../component/nav'
import HighlightFont from '../component/highlightFont'
import HighlightButton from '../component/highlightButton'
import styles from './index.module.less'

export default () => {
  const [navValue, setNavValue] = useState(1)

  useEffect(() => {
    util.track('mn-novice-recommendation-2-page', {
    })
  }, [])

  return <div>
    <Nav
      options={[
        { label: '邀请协作', serialNumber: '01', value: 1 },
        { label: '添加批注', serialNumber: '02', value: 2 },
        { label: '审核选款', serialNumber: '03', value: 3 },
        { label: '探索更多', serialNumber: '04', value: 4 },
      ]}
      value={navValue}
      onChange={(val) => {
        setNavValue(val)
        document.querySelector(`#noviceRecommendationPanelPhase2-${val}`).scrollIntoView({ behavior: 'smooth', block: 'start' })
      }}
    />
    <div className={styles.noviceRecommendation}>
      <div className="noviceRecommendationTop">
        <div className="noviceRecommendationTopBg" style={{ backgroundImage: 'url(https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/background.png)' }} />
        <div className="noviceRecommendationTopFgWrap">
          <div className="noviceRecommendationTopFg" style={{ backgroundImage: 'url(https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/foreground2.png)' }} />
        </div>
      </div>
      <div className="noviceRecommendationMainWrap">
        <div className="noviceRecommendationMain">
          <Panel
            titleDir="noviceRecommendationImage02"
            style={{ height: '1056px' }}
            title="panel01"
            id="noviceRecommendationPanelPhase2-1"
            onChange={(val) => {
              if (val) {
                setNavValue(1)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationPanelPhase201}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    作为一款云协作选款平台，美念可以成为<HighlightFont>团队空间，整合各部门各成员的款式资源，</HighlightFont>
                    <HighlightFont>同步款式动态信息</HighlightFont>方便团队成员对接。只需要设置灵感集的<HighlightFont>「协作成员」</HighlightFont>，赋予不同
                    成员不同的协作权限。
                  </div>
                </div>
                <div className="column2">
                  比如：赋予团队leader“审核者”权限，可以审核、采集、编辑、删除款式；赋予同事“采集者”权限，可以往里采集添加图片；赋予其他部门成员“查看者”权限，只能查看灵感集款式。
                </div>
                <div style={{ position: 'relative' }}>
                  <MouseIcon style={{ left: '159px', top: '158px' }} />
                  <MouseIcon style={{ left: '367px', top: '94px' }} />
                  <img style={{ width: '937px', height: '438px', marginTop: '32px', marginLeft: '18px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation02/1-1.png" />
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-2-click', {
                    module1: '邀请协作',
                  })
                  window.open('/meinian/home/coll')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage02"
            style={{ height: '931px', marginTop: '56px' }}
            title="panel02"
            id="noviceRecommendationPanelPhase2-2"
            onChange={(val) => {
              if (val) {
                setNavValue(2)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationPanelPhase202}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    在款式详情页，可对款式内所有图片进行<HighlightFont>框选「批注」</HighlightFont>，标注款式细节；
                    或在图片下方进行<HighlightFont>「评论」</HighlightFont>，记录选款灵感，沉淀讨论结果。
                  </div>
                </div>
                <div style={{ position: 'relative' }}>
                  <MouseIcon style={{ left: '108px', top: '505px' }} />
                  <MouseIcon style={{ left: '740px', top: '48px' }} />
                  <img style={{ width: '820px', height: '499px', marginTop: '24px', marginLeft: '18px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation02/2-1.png" />
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-2-click', {
                    module1: '添加批注',
                  })
                  window.open('/meinian/home/style-trend')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage02"
            style={{ height: '733px', marginTop: '56px' }}
            title="panel03"
            id="noviceRecommendationPanelPhase2-3"
            onChange={(val) => {
              if (val) {
                setNavValue(3)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationPanelPhase203}>
                <div className="column1">
                  <div className={styles.noviceRecommendationMainPotion} />
                  <div className="column1Text">
                    <HighlightFont>「审核」</HighlightFont>是美念独有的选款标记功能，通过<HighlightFont>新建灵感集时选择审核层级</HighlightFont>，标记灵感集
                    内款式的<HighlightFont>通过状态</HighlightFont>用来筛选款式或设计审稿，非常方便！
                  </div>
                </div>
                <div style={{ position: 'relative' }}>
                  <MouseIcon style={{ left: '206px', top: '268px' }} />
                  <img style={{ width: '887px', height: '300px', marginTop: '24px', marginLeft: '18px' }} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendation02/3-1.png" />
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-2-click', {
                    module1: '审核选款',
                  })
                  window.open('/meinian/home/all')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
          <Panel
            titleDir="noviceRecommendationImage02"
            style={{ height: '416px', marginTop: '56px' }}
            title="panel04"
            id="noviceRecommendationPanelPhase2-4"
            onChange={(val) => {
              if (val) {
                setNavValue(4)
              }
            }}
          >
            <div className="noviceRecommendationPanelContent">
              <div className={styles.noviceRecommendationPanelPhase204}>
                <div className={styles.noviceRecommendationMainPotion} />
                <div className="columnText">
                  当然，美念的功能远远不止于此，更多详细内容，可移步<HighlightFont>帮助中心</HighlightFont>
                  查看，或是联系我们为您的团队定制专属解决方案～
                </div>
              </div>
              <HighlightButton
                style={{ marginTop: '64px' }}
                className={styles.highlightButtonBig}
                onClick={() => {
                  util.track('mn-novice-recommendation-2-click', {
                    module1: '探索更多',
                  })
                  window.open('/meinian/document')
                }}
              >去看看</HighlightButton>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  </div>
}
